import React from 'react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/gvkgUj7q9QwxHEt8wA7Vkh/ChatGPT_Image_23_feb_2026,_10_54_32.png';
const BG_IMG = 'https://cdn.magicpatterns.com/uploads/bF9FQNBjLgbPnbbV6rox77/WhatsApp_Image_2026-02-23_at_12.46.49.jpg';
const BENEFITS = ['100% digital', 'Acceso inmediato', 'A tu ritmo', 'Sin experiencia previa'];
export function HeroSection() {
  return <section className="min-h-screen pt-24 pb-12 md:pt-28 md:pb-20 px-4 overflow-hidden relative flex flex-col justify-center" data-id="element-186">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url(${BG_IMG})`
    }} data-id="element-187"></div>
      <div className="absolute inset-0 bg-[#0f0f1a]/50" data-id="element-188"></div>

      <div className="absolute inset-0 pointer-events-none" data-id="element-189">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#d4a017]/10 rounded-full blur-[120px]" data-id="element-190"></div>
        <div className="absolute bottom-0 right-1/4 w-[300px] h-[300px] bg-[#c82333]/10 rounded-full blur-[100px]" data-id="element-191"></div>
      </div>

      <div className="container mx-auto max-w-4xl text-center relative z-10" data-id="element-192">
        {/* Title */}
        <h1 className="animate-in delay-100 mb-6" data-id="element-193">
          <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold tracking-tight leading-[1.1] text-transparent bg-clip-text bg-gradient-to-r from-[#d4a017] via-[#f0c040] to-[#d4a017]" style={{
          textShadow: '0 4px 20px rgba(0,0,0,0.5)'
        }} data-id="element-194">
            FORMACIÓN INTEGRAL DE REIKI
          </span>
        </h1>

        {/* Subtitle */}
        <div className="animate-in delay-200 text-gray-200 mb-5 max-w-2xl mx-auto leading-relaxed px-2 text-xl md:text-2xl space-y-2" style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontWeight: 500
      }} data-id="element-195">
          <p data-id="element-196">Aprendé a sanar tu energía</p>
          <p data-id="element-197">y convertí el Reiki</p>
          <p className="text-white font-semibold" data-id="element-198">
            en una herramienta de transformación personal.
          </p>
        </div>

        {/* Refuerzo */}
        <p className="animate-in delay-250 text-[#f0c040] font-serif font-semibold text-base md:text-lg tracking-wide mb-5" data-id="element-199">
          Formación completa · Paso a paso · Desde cero
        </p>

        {/* Beneficios rápidos */}
        <div className="animate-in delay-300 flex flex-wrap justify-center gap-3 sm:gap-5 mb-8" data-id="element-200">
          {BENEFITS.map((b, i) => <span key={i} className="flex items-center gap-1.5 text-sm md:text-base text-gray-200 font-medium" data-id="element-201">
              <span className="text-green-400 font-bold" data-id="element-202">✔</span> {b}
            </span>)}
        </div>

        {/* Product Image */}
        <div className="animate-scale-in delay-400 block mx-auto max-w-xs sm:max-w-md md:max-w-lg mb-8" data-id="element-203">
          <div className="relative animate-float" data-id="element-204">
            <div className="absolute -inset-4 md:-inset-6 bg-gradient-to-br from-[#d4a017]/20 via-transparent to-[#c82333]/20 rounded-3xl blur-3xl opacity-80" data-id="element-205"></div>
            <div className="relative p-1 rounded-2xl bg-gradient-to-br from-[#d4a017]/30 via-white/5 to-[#d4a017]/20 shadow-[0_12px_60px_rgba(0,0,0,0.6)] border border-white/10" data-id="element-206">
              <div className="rounded-xl overflow-hidden bg-[#1a1a2e]" data-id="element-207">
                <img src={PRODUCT_IMG} alt="Formación Integral de Reiki" className="w-full object-cover block mix-blend-screen" data-id="element-208" />
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="animate-in delay-500 flex flex-col items-center gap-3 w-full max-w-xl mx-auto" data-id="element-209">
          <a href="#selectable-cards" className="w-full block px-6 py-4 md:py-5 rounded-xl text-white font-bold text-base sm:text-lg md:text-xl tracking-widest uppercase transition-all shadow-[0_0_30px_rgba(200,35,51,0.4)] hover:shadow-[0_0_40px_rgba(200,35,51,0.6)] hover:-translate-y-1 bg-[#c82333] hover:bg-[#bd2130] border border-red-500/50" style={{
          fontFamily: "'Cormorant Garamond', serif",
          letterSpacing: '0.1em'
        }} data-id="element-210">
            🌿 QUIERO VER LA FORMACIÓN
          </a>

          <p className="text-gray-400 text-xs md:text-sm font-medium" data-id="element-211">
            Acceso 100% digital · Desde cero · A tu ritmo ·{' '}
            <span className="text-[#f0c040] font-bold" data-id="element-212">
              💳 Hasta 3 cuotas sin interés
            </span>
          </p>
        </div>
      </div>
    </section>;
}